import { MapPin, Clock, Phone, MessageCircle, Sparkles } from "lucide-react";
import { BUSINESS } from "@/constants";
import { Reveal } from "@/components/Reveal";

export default function Contact() {
  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="pt-28 sm:pt-36"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="mb-16">
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gold">
            Find Us
          </span>
          <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-bone leading-[1.05]">
            In the heart of
            <em className="text-gold-gradient italic"> old Dubai.</em>
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">
          <Reveal className="space-y-4">
            <div className="border border-line rounded-sm p-6">
              <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-sand mb-4">
                Areas We Serve
              </p>
              <div data-testid="areas-served" className="flex flex-wrap gap-2">
                {["Bur Dubai","Al Fahidi","Meena Bazaar","Al Souq Al Kabeer","Al Raffa","Al Mankhool","Karama","Oud Metha","Al Jafiliya","Al Hamriya"].map((a) => (
                  <span key={a} className="text-xs text-bone/80 border border-line rounded-full px-3.5 py-1.5 hover:border-gold/60 hover:text-gold transition-colors duration-300">
                    {a}
                  </span>
                ))}
              </div>
            </div>
            {[
              {
                icon: MapPin,
                label: "Address",
                value: BUSINESS.address,
                href: BUSINESS.mapsLink,
                testid: "contact-address",
              },
              {
                icon: Clock,
                label: "Hours",
                value: BUSINESS.hours,
                testid: "contact-hours",
              },
              {
                icon: Phone,
                label: "Call Us",
                value: BUSINESS.phoneDisplay,
                href: BUSINESS.phoneTel,
                testid: "contact-phone",
              },
              {
                icon: MessageCircle,
                label: "WhatsApp",
                value: "+971 50 179 9925",
                href: BUSINESS.whatsapp,
                testid: "contact-whatsapp",
              },
            ].map((row) => {
              const Inner = (
                <div className="flex items-center gap-5 border border-line rounded-sm p-6 hover:border-gold/50 transition-colors duration-500 group">
                  <span className="w-12 h-12 shrink-0 rounded-full border border-gold/40 text-gold flex items-center justify-center group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
                    <row.icon size={18} strokeWidth={1.5} />
                  </span>
                  <div>
                    <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-sand">
                      {row.label}
                    </p>
                    <p className="mt-1 text-bone">{row.value}</p>
                  </div>
                </div>
              );
              return row.href ? (
                <a
                  key={row.label}
                  href={row.href}
                  target={row.href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  data-testid={row.testid}
                  className="block"
                >
                  {Inner}
                </a>
              ) : (
                <div key={row.label} data-testid={row.testid}>
                  {Inner}
                </div>
              );
            })}
          </Reveal>

          <Reveal delay={0.15} className="min-h-[320px]">
            <div className="h-full border border-line rounded-sm overflow-hidden">
              <iframe
                title="Shine Space Beauty Salon location map"
                data-testid="contact-map"
                src={BUSINESS.mapsEmbed}
                className="w-full h-full min-h-[320px] grayscale invert-[0.9] contrast-[0.9]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-24 border-t border-line">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-10 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 rounded-full border border-gold/60 flex items-center justify-center text-gold">
              <Sparkles size={13} strokeWidth={1.5} />
            </span>
            <span className="font-serif text-lg text-bone">
              Shine <span className="italic text-gold">Space</span>
              <span className="text-sand text-sm ml-2">Beauty Salon · Bur Dubai</span>
            </span>
          </div>
          <p className="text-xs text-sand/70 tracking-wide" data-testid="footer-copy">
            © {new Date().getFullYear()} Shine Space Beauty Salon. Ladies only.
          </p>
        </div>
      </div>
    </footer>
  );
}
